// checks for session and navigates accordingly

import { useEffect } from "react";
import { useNavigate }          from "react-router-dom";

export const RootComponent = () => {

  const navigate = useNavigate()
  const isLoggedIn = true

  useEffect(() => {

    if (isLoggedIn) {
      navigate('/dashboard')
    } else {
      navigate('/auth/login')
    }
  })

  return (
    <></>
  )

}